import { useState, useCallback } from 'react';
import { AiSmartFolder } from '../types';
import { aiApi } from '../services/communicationsApi';

const DEFAULT_FOLDERS: AiSmartFolder[] = [
  { id: 'focus', name: 'Focus' },
  { id: 'news', name: 'News' },
  { id: 'other', name: 'Other' }
];

export const useAiSmartFolders = () => {
  const [folders, setFolders] = useState<AiSmartFolder[]>(DEFAULT_FOLDERS);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchSmartFolders = useCallback(async (channelId: number) => {
    setLoading(true);
    setError(null);
    try {
      const data = await aiApi.getSmartFolders(channelId);
      setFolders(data.length > 0 ? data : DEFAULT_FOLDERS);
      return data;
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to load smart folders');
      setFolders(DEFAULT_FOLDERS);
      return DEFAULT_FOLDERS;
    } finally {
      setLoading(false);
    }
  }, []);

  const clearFolders = useCallback(() => {
    setFolders(DEFAULT_FOLDERS);
    setError(null);
  }, []);

  return { folders, loading, error, fetchSmartFolders, clearFolders };
};
